import * as defaultImport from "@splunk/react-icons/EyeSlashed";
export * from "@splunk/react-icons/EyeSlashed";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
